import pageTransition from './page-transition.js';
import canvas from './canvas.js';
import smoothScroll from './smooth-scroll.js';